import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PartnerDto, SchoolBillDto } from '../api/models';
import { AngularDeviceInformationService } from 'angular-device-information';
import { QRCodeComponent } from 'angularx-qrcode';
import * as bootstrap from 'bootstrap';
import { ReceiptControllerService, SchoolBillControllerService, SchoolControllerService } from '../api/services';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-school-payment-anticipation',
  imports: [ReactiveFormsModule,QRCodeComponent],
  templateUrl: './school-payment-anticipation.component.html',
  styleUrl: './school-payment-anticipation.component.css',
})
export class SchoolPaymentAnticipationComponent implements OnInit {


  listMois = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  message: string= '';
  isBill:boolean = true;
  isPayment:boolean = false;
  formBill:FormGroup;
  formPayment:FormGroup;
  schools?:Array<PartnerDto>;
  student?:SchoolBillDto;
  isWallet:boolean = false;
  fees:number = 0;
  taxe:number = 0;
  paymentNetwork:string = '';
  paymentNetworkOtpion:string = '';
  qrCode:string = '';
  isDesktop:boolean = false;
  selectedSchool?:PartnerDto;
  amouunt:number = 0;
  mminAmount=0;
  processing=false;


  constructor(builder: FormBuilder,private deviceInfo:AngularDeviceInformationService,
    private schoolService:SchoolControllerService,
    private billService:SchoolBillControllerService,
    private receiptService:ReceiptControllerService,
    private route:Router,
    private activeRoute:ActivatedRoute
  ) {
    this.formBill = builder.group({
      school: ['',[Validators.required]],
      idStudent: ['',[Validators.required]],
    });
    this.formPayment = builder.group({
      school: ['',[Validators.required]],
      idStudent: ['',[Validators.required]],
      amount: ['',[Validators.required]],
      echeances: builder.array(this.listMois.map(() => builder.control(false))),
      phone: ['']
    });
    this.isDesktop = this.deviceInfo.isDesktop();
    this.mminAmount= environment.MIN_AMOUNT_SCHOOL_PAYMENT;
   }

    ngOnInit(): void {
      this.loadSchool();

       this.activeRoute.params.subscribe(p=>{
      if(p['idSchool'] && p['idStudent']){
        console.log("id school "+p['idSchool']+" id student "+p['idStudent']);
        this.formBill.patchValue({
          school:p['idSchool'],
          idStudent:p['idStudent']
        });
        this.findStudent();
      }
    })
    }
    getAmount(){
      if(this.formPayment.value.amount){
      this.amouunt = this.formPayment.value.amount;
    }
  }

   findStudent() {
   
     this.billService.findStudent1(
      this.formBill.value.idStudent,
      this.formBill.value.school
     ).subscribe(
      {
        next:(resp)=>{
           this.selectedSchool = this.schools?.find(sch=>sch.id == this.formBill.value.school);
          if(resp.amount &&resp.amount>0){
            this.message ='Vous avez des arriérés de paiement, veuillez regler ces arriérés avant de pouvoir payer par anticipation';
            const elt =document.getElementById('modErrPay');
                           const modAdd = new bootstrap.Modal(elt!!);
                           modAdd.show();
            
          }else {
            this.student = resp;
            this.formPayment.patchValue({
              school:this.formBill.value.school,
              idStudent:this.formBill.value.idStudent
            });
             this.isBill = false;
            this.isPayment = true;
          }
          
        },
        error:(err)=>{
          console.log("eer"+err.error.message);
          
          this.message =err.error.message;
          const elt =document.getElementById('modErrPay');
                           const modAdd = new bootstrap.Modal(elt!!);
                           modAdd.show();
        }
        }
      );
    
   }

   getEcheances(){
    let echeances:boolean[] = this.formPayment.value.echeances; 
    for(let i=0;i<echeances.length;i++){
      console.log("echeance "+i+" "+echeances.at(i));
    }
    return this.listMois.filter((m,i)=> echeances[i]);
   }
   
   processPayment() {
    this.processing=true;
    let echeances = this.getEcheances();
    console.log("pay {}",this.formPayment.value,echeances);

    this.billService.payAnticipated({
      idBill:0,
      amount: this.formPayment.value.amount,
      idSchool:this.formPayment.value.school,
      idStudent:this.formPayment.value.idStudent,
      paymentNetwork:this.paymentNetwork,
      paymentMean:this.formPayment.value.phone,
      echeances: this.getEcheances()
    }).subscribe(
      {
        next:(resp)=>{
          this.processing=false;
          if(this.paymentNetwork.toUpperCase() =='CARD'){
            this.openUrl(resp.paymentUrl??'');
          }else {
            this.isPayment = false;
            this.isBill = false;
            this.qrCode = resp.paymentUrl??'';
            this.finalizePayment(resp.reference!!);
              
          }
        },
        error:(err:HttpErrorResponse)=>{
          this.processing=false;
          console.log("error anticipation"+err.error.message);
          
          this.message =err.error.message;
          const elt =document.getElementById('modErrPay');
                           const modAdd = new bootstrap.Modal(elt!!);
                           modAdd.show();
        }
    
   }); 
  }
   isValid(){
    let valid =this.formPayment.valid;
    if(this.paymentNetwork =='card'){
      valid = valid&&true;
    }else {
      let phone = this.formPayment.value.phone;
    valid = valid&&phone!=null&&phone.length>=9;
      if(this.paymentNetwork.toUpperCase() =='OMSN'){
        
          this.paymentNetworkOtpion='maxit';
        
      }
     

    }
    return valid;
  }
   completeForm(paymentNetwork:string){

    this.formBill.reset();
    this.paymentNetwork = paymentNetwork;
    const methods = document.querySelectorAll('.payment-method');

    if(this.paymentNetwork.toLocaleLowerCase() == 'card'){
      this.isWallet = false;
   
    }else {
      this.isWallet =true;

    }

    methods.forEach(element => {
      
      if(element.getAttribute('data-method') == paymentNetwork){
        element.classList.add('active');

      }else {
        element.classList.remove('active');
      }
      
    });

  }
   onSelectPaymentMethod(paymentMethod:string){

      this.billService.getFeesAndTaxes({
       idBill:0,
        amount: this.formPayment.value.amount,
        idSchool:this.formPayment.value.school,
        idStudent:this.formPayment.value.idStudent,
        paymentMode:paymentMethod
      }).subscribe(
        {
          next:(resp) =>{
            this.taxe =resp.taxes;
            this.fees =resp.fees-this.taxe;
            this.completeForm(paymentMethod);

          },
          error:(err)=>{
              console.log("eer"+err.error.message);

              this.message =err.error.message;
              const elt =document.getElementById('modErrPay');
                               const modAdd = new bootstrap.Modal(elt!!);
                               modAdd.show();
          }
        }
      );

    }

  loadSchool(school?:number){

    this.schoolService.findSchool(
      environment.codeParent,
      environment.codeCountry,
      school
    ).subscribe(
      {
        next:(resp)=>{
          this.schools=resp;
          if(school!!>0){
        }
        }
      }
    );
  } 
  openUrl(url:string){
  
       window.open(url,'_self');
    }

     async finalizePayment(reference:string){
      
      this.receiptService.getPaymentDetails(
        reference
      ).subscribe({
        next:(resp)=>{
          console.log(resp);
          if(resp.status =='PENDING'){
            setTimeout(()=>
              {
                this.finalizePayment(reference);
              },
              20000);
          }else {
            this.route.navigateByUrl('receipt/'+reference);
            
          }
          
        },
        
      });
    }
    
    
}
